import { Link } from 'react-router-dom';

import { useCollections } from '@/features/collections/useCollections';
import type { GenerationStatus, HistoryEntry } from '@/types/history';
import { describeSelections } from '@/utils/selections';

const STATUS_LABELS: Record<GenerationStatus, string> = {
  queued: 'В очереди',
  processing: 'Генерируется',
  completed: 'Готово',
  failed: 'Не удалось',
};

interface HistoryCardProps {
  entry: HistoryEntry;
  onDelete: (id: string) => void;
  isDeleting: boolean;
}

export function HistoryCard({ entry, onDelete, isDeleting }: HistoryCardProps) {
  const { byId } = useCollections();
  const collection = byId.get(entry.collectionId);
  const collectionTitle = collection?.title ?? entry.collectionId;

  const thumbnail = entry.thumbnailUrl ? (
    <img
      src={entry.thumbnailUrl}
      alt=""
      className="h-16 w-16 shrink-0 rounded-card object-cover"
    />
  ) : (
    <div
      className="flex h-16 w-16 shrink-0 items-center justify-center rounded-card bg-surface-2 text-xs text-text-3"
      aria-label="Превью недоступно"
    >
      нет фото
    </div>
  );

  return (
    <li className="flex items-center gap-4 rounded-card border border-border bg-surface p-3">
      {thumbnail}

      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-text">{collectionTitle}</p>
        <p className="truncate text-xs text-text-3">{describeSelections(collection, entry.selections)}</p>
        <p className="text-xs text-text-3">{new Date(entry.createdAt).toLocaleString('ru-RU')}</p>
      </div>

      <span className="shrink-0 text-xs text-text-2">{STATUS_LABELS[entry.status]}</span>

      {entry.status === 'completed' && (
        <Link to={`/result/${entry.id}`} className="shrink-0 text-sm text-accent hover:underline">
          Открыть
        </Link>
      )}

      <button
        type="button"
        onClick={() => onDelete(entry.id)}
        disabled={isDeleting}
        className="shrink-0 text-sm text-danger hover:underline disabled:opacity-50"
      >
        Удалить
      </button>
    </li>
  );
}
